import {
  Button,
  ButtonGroup,
  Container,
  HStack,
  Table,
  Tag,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";

import { DealerOrganizationUsersActionsMenu } from "src/routes/DealerOrganization/DealerOrganizationUsersActionsMenu";
import { DealerOrganizationUsersFilterBar } from "src/routes/DealerOrganization/DealerOrganizationUsersFilterBar";
import {
  useDealerOrganizationQueryData,
  useDealerUsersQuery,
} from "src/routes/DealerOrganization/queries";
import { Loading } from "src/common/Loading";
import { SortableTh } from "src/common/SortableTh";
import { PageContent } from "src/layout/PageContent";
import { formatPhoneNumber } from "src/common/phone-numbers";
import { SomethingWentWrong } from "src/common/ErrorBoundary/SomethingWentWrong";
import { PageHeader, PageHeaderTitle } from "src/layout/PageHeader";
import { AuthService } from "src/common/AuthService";
import { StaffRole } from "src/common/types";

export const DealerOrganizationUsers = () => {
  const { id } = useParams<"id">();

  if (!id) {
    return (
      <Container maxW="7xl" h="calc(100vh)" centerContent={true}>
        <SomethingWentWrong
          error={new Error("Dealer Organization ID is not provided.")}
        />
      </Container>
    );
  }

  const navigate = useNavigate();
  const users = useDealerUsersQuery(id);
  const organization = useDealerOrganizationQueryData(id);
  const role = AuthService.hooks.useStaffUserRole();

  return !users.data ? (
    <Loading />
  ) : (
    <PageContent>
      <PageHeader
        buttons={
          <ButtonGroup>
            <DealerOrganizationUsersFilterBar />
            {role === StaffRole.Admin && (
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={() => navigate(`/dealers/${id}/users/invite`)}
              >
                Add
              </Button>
            )}
          </ButtonGroup>
        }
      >
        <PageHeaderTitle>Dealer Staff Users</PageHeaderTitle>
      </PageHeader>

      <Table variant="simple">
        <Thead>
          <Tr>
            <SortableTh sortKey="name">Name</SortableTh>
            <SortableTh sortKey="email">Email</SortableTh>
            <SortableTh sortKey="phone">Phone Number</SortableTh>
            <SortableTh sortKey="role">Role</SortableTh>
          </Tr>
        </Thead>
        <Tbody>
          {users.data.map((dealerUser) => {
            return (
              <Tr key={dealerUser.dealerUserId}>
                <Td>
                  <HStack>
                    {organization?.pointOfContactId ===
                      dealerUser.dealerUserId && (
                      <Tag
                        key={`dealer-contact-${dealerUser.dealerUserId}`}
                        size="sm"
                        colorScheme="green"
                      >
                        Dealer Contact
                      </Tag>
                    )}
                    <Text>
                      {dealerUser.user.firstName} {dealerUser.user.lastName}
                    </Text>
                  </HStack>
                </Td>
                <Td>{dealerUser.user.email}</Td>
                <Td>{formatPhoneNumber(dealerUser.user.phone)}</Td>
                <Td textTransform="capitalize">{dealerUser.role}</Td>
                <Td>
                  <DealerOrganizationUsersActionsMenu
                    dealerUser={dealerUser}
                    isPointOfContact={
                      organization?.pointOfContactId === dealerUser.dealerUserId
                    }
                  />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </PageContent>
  );
};
